<template>
  <div>
    <div
      v-for="(item, index) in titleList"
      :key="index"
      class="mb-2"
    >
      <!-- <el-row>
        <el-col :span="20"> -->
      <el-input
        class="mr-1 hideCount"
        v-model="item.name"
        :placeholder="`最多添加5个${type}`"
        @input="change"
        @blur="() => handleBlur(index)"
      >
        <template #suffix>
          <span
            class="text-[#666666] pr-1"
            style="font-size: 11px"
          >
            {{ getByteLength(item.name) }}/{{ maxlength }}
          </span>
        </template>
      </el-input>
      <!-- </el-col>
        <el-col
          class="ml-1"
          :span="3"
        > -->
      <el-button
        type="text"
        size="mini"
        @click="deleItem(index)"
        >删除</el-button
      >
      <el-button
        type="primary"
        size="mini"
        v-if="index === 0 && titleList.length < 5"
        @click="addItem"
        >添加</el-button
      >

      <!-- </el-col>
      </el-row> -->
    </div>
  </div>
</template>
<script>
import { getByteLength } from '@/views/google/create/components/creatives/index';
export default {
  props: {
    type: {
      type: String,
      default: '标题',
    },
    value: {
      type: Array,
      default: () => [],
    },
    maxlength: {
      type: Number,
      default: 60,
    },
  },
  data() {
    return {
      // 使用本地数据存储，避免计算属性的响应式问题
      localList: [],
    };
  },
  computed: {
    titleList: {
      get() {
        return this.localList;
      },
      set(val) {
        this.localList = val;
      },
    },
  },
  watch: {
    value: {
      handler(val) {
        // 过滤掉 null/undefined 值，确保数据有效
        const validValues = Array.isArray(val) ? val.filter((v) => v !== null && v !== undefined) : [];
        this.localList = validValues.length ? validValues.map((v) => ({ name: v })) : [{ name: '' }];
      },
      immediate: true,
    },
  },
  methods: {
    getByteLength(str) {
      return getByteLength(str);
    },
    /**
     * 添加
     */
    addItem() {
      this.localList.push({ name: '' });
      this.change();
    },
    /**
     * 删除
     */
    deleItem(index) {
      if (this.localList.length === 1) {
        this.$message({
          type: 'warning',
          message: `请至少保留一个${this.type}`,
        });
        return false;
      }
      this.localList.splice(index, 1);
      this.change();
    },
    /**
     * 导出数据
     */
    change() {
      // 保留所有输入值（包括空字符串），只过滤 null/undefined
      const result = this.localList.map((v) => v.name);
      this.$emit('input', result);
    },
    /**
     * 失去焦点时去除两头空格
     */
    handleBlur(index) {
      if (this.localList[index] && typeof this.localList[index].name === 'string') {
        this.localList[index].name = this.localList[index].name.trim();
        this.change();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.hide-count .el-input__count {
  display: none; /* 隐藏默认计数 */
}
</style>
